import { Component, Input } from "@angular/core";

export interface IImageCheckbox {
	display: string;
	src: string;
	alt: string;
	isEnabled: boolean;
	isChecked: boolean;
}

@Component({
	selector: "image-checkbox",
	template: `
		<div class="col-sm-4">
			<div class="panel panel-default text-center">
				<img class="padding-top-xs" [src]="imageCheckbox.src" [alt]="imageCheckbox.alt">
				<div class="checkbox margin-xxs margin-top-sm" [ngClass]="{'disabled' : !imageCheckbox.isEnabled}">
					<label class="icheck-label nowrap">
						<div class="icheckbox_flat-green"
							[ngClass]="{'icheckbox_flat-aero' : !imageCheckbox.isEnabled, 'checked' : imageCheckbox.isChecked}"	style="position: relative;">
							<input class="icheck"
									type="checkbox"
									checked=""
									style="position: absolute; opacity: 0;"
									[(ngModel)]="imageCheckbox.isChecked"
									[disabled]="!imageCheckbox.isEnabled">
							<ins class="iCheck-helper"
								style="position: absolute;
								top: 0%; left: 0%;
								display: block;
								width: 100%;
								height: 100%;
								margin: 0px;
								padding: 0px;
								background: rgb(255, 255, 255);
								border: 0px;
								opacity: 0;">
							</ins>
						</div> {{imageCheckbox.display}}
					</label>
				</div>
			</div>
		</div>
` })
export class ImageCheckboxComponent {
	@Input() imageCheckbox: IImageCheckbox;
}
